
function openWinPop(url, width, height) {
    const left = (screen.width - width) / 2 - 1;
    const top = (screen.height - height) / 2 - 1;
    window.open(
        url,
        "",
        width && height ? `scrollbars=1, width=+${width}, height=${height}, left=${left}, top=${top}, scrollbars=yes, resizable=yes` : ''
    );
}

function handleError(error) {
    let message = "default-error-message";

    if (error.response != undefined) {
        if (error.response.data != undefined) {
            if (error.response.data instanceof Blob) {
                const reader = new FileReader();
                reader.onload = (event) => {
                    try {
                        const parsedMessage = JSON.parse(event.target.result).message;
                        message = parsedMessage; // Blob에서 메시지 가져오기
                    } catch (e) {
                        // JSON 파싱 오류 발생 시 기본 메시지 사용
                        message = "default-error-message";
                    } finally {
                        alert(message);
                    }
                };
                reader.readAsText(error.response.data);
                return;
            } else {
                message = error.response.data.message;
            }
        }
    }

    alert(message);
}

function isNumeric(str) {
    return /^\d+$/.test(str);
}

export { openWinPop, handleError, isNumeric }